import { LoginScreen, RegisterScreen } from "views/Auth"

const authRoute = {
  login: {
    component: LoginScreen,
    path: "/login",
    url: "/auth/login",
  },
  register: {
    component: RegisterScreen,
    path: "/register",
    url: "/auth/register",
  },
}

export default authRoute
